import crudBase from './crudBase';
import { useStore } from 'vuex';
import indexedDB from '@/commons/indexedDB';
import _ from 'lodash';

export default class crudBaseCache extends crudBase {

  constructor (name, api) {
    super(name, api);

    const getName = () => {
      return `cacheDi_${name}`;
    };



    this.actions = Object.assign(this.actions, {
      /**
      * Thực hiện get cache từ server về, nếu server lỗi thì lấy dữ liệu trong cache
      * @param {*} dispatch 
      * @param {*} commit 
      * @param {*} defaultSort 
      * @param {*} key 
      * @returns 
      */
      getAndSetCache: async function ({ dispatch, commit }, {defaultSort, key, payload}) {
        const indexDb = new indexedDB();
        let remoteData = [];
        try {
          remoteData = await dispatch(`getFullList`, {
            sort: defaultSort,
          });
          await indexDb.set(key, {
            localVersion: payload.remoteVersion,
            localData: remoteData
          });
        } catch (error) {
          console.log(`Error when get data from server with module ${name} error: ${error}`);
          //Nếu xảy ra lỗi khi lấy dữ liệu từ server thì lấy luôn trong cache
          const dataExistInCache = await indexDb.get(key);
          if (dataExistInCache && dataExistInCache.localData) {
            remoteData = dataExistInCache.localData;
          }
        }

        return remoteData;
      },
      loadFullCache: async function (
        { dispatch, commit, getters },
        payload
      ) {
        if (!payload) {
          payload = {};
        }
        const indexDb = new indexedDB();
        const key = getName();
        const data = await indexDb.get(key);
        const config = getters[`_config`];
        const defaultSort = config.defaultSort ? config.defaultSort : config?.field?.code;
        if (data) {
          const { localVersion, localData } = data;
          // gán lại remoteVersion
          // pqkhanh  28.03.2023
          if (payload.isReload && !payload.remoteVersion) {
            payload.remoteVersion = localVersion
          }
          if (localVersion < payload.remoteVersion || !localData || payload.isReload) {
            const remoteData = await dispatch('getAndSetCache', {defaultSort, key, payload});
            commit('setItems', remoteData);
          } else {
            commit('setItems', localData);
          }
        } else {
          const remoteData = await dispatch('getAndSetCache', {defaultSort, key, payload});
          commit('setItems', remoteData);
        }
      },

      loadSummary: async function (context, payload) { },
      /**
       * Load full data
       */
      getFullList: async function (context, payload) {
        context.commit('updateLoading', true);

        let res = await api.getFullListCache(payload || {});
        context.commit('updateLoading', false);

        return res;
      },
      setItems(context, payload) {
        context.commit('setItems', payload);
      }
    });

    //#region Mutation
    this.mutations = Object.assign(this.mutations, {
      /**
       * Cập nhật khi thêm bản ghi
       */

      insertItem(state, data) {
        let newItem = data;
        state.items = _.concat(newItem, state.items);

        state.version++;
      },
      /**
       * Sắp xếp lại danh sách khi thêm bản ghi mới
       * ncdinh 29/12/2022
       * @param {*} state
       */
      sortByCode(state) {
        let code = state._config?.field?.code;

        state.items = state.items.sortObject(code);
      },

      setItems(state, data) {
        state.items = data;
      },
    });

    //#endregion
  }
}
